export default __webpack_public_path__ + "static/download-windscribe-image-d56b67718e8dfa15c74c4329f89e14a6.png";